// extracted by mini-css-extract-plugin
module.exports = {"text":"NavigationLink_text__GoIvA","current":"NavigationLink_current__9Cv_r"};